export default __webpack_public_path__ + "static/media/chevron-down.44a38891.svg";